import axios from "axios";
import { useState } from "react";

export const useIsLoading = () =>{
    const [isLoading, setIsLoading] = useState(false);
    const [firstLoad,setFirstLoad] = useState(true);
    axios.interceptors.request.use((req)=>{
        if(!isLoading){
          setIsLoading(true);
        }
       // console.log("appjs axios intercepter called-------------------->",req)
        return req;
      })
      axios.interceptors.response.use(res=>{
        //console.log("axios intercepter response ",res)
        if(firstLoad){
          setIsLoading(false);
          setFirstLoad(false)
        }
        if(isLoading){
          setIsLoading(false)
        }
        return res;
      },err=>{
       // console.log("axios intercepter error: ",err)
        if(firstLoad){
          setIsLoading(false);
          setFirstLoad(false)
        }
        if(isLoading){
          setIsLoading(false)
        }
        return err;
      })
    return {isLoading}
}